import { useTranslation } from "react-i18next";
import FormGroupTile from "../../../basic/FormGroupTile";
import { Spinner } from "react-bootstrap";
import { useSimpleCan } from "../../../../../config/casl/casl";
import { needsCampaignNameCheck, useCampaignNameChecks } from "../useCampaignNameChecks";

// Map a campaign-name field type (backend enum) to the English label used in the UI.
// Defined here as a plain mapping so the leaf JSON keys are the visible English labels.
const CAMPAIGN_TYPE_LABEL_KEY = {
  auto_name: "Harvesting Campaign Name (Auto Campaign)",
  manual_name: "Manual Campaign Name",
  contextual_name: "Contextual Campaign Name",
  audience_name: "Audience Campaign Name",
  walmart_manual_campaign_name: "Walmart Manual Campaign Name",
  walmart_auto_campaign_name: "Walmart Auto Campaign Name",
};

const CampaignNameField = ({
  state,
  campaignType,
  campaignName,
  handleCampaignNameChange,
  marketPlace,
  labelClassName,
  overrideLabelText,
  overridePlaceholderText,
  key,
  customLabelStyles = null,
  formControlClasses = "",
  isDisabled,
}) => {
  const { t } = useTranslation(["advertising"]);

  const labelText =
    overrideLabelText ? overrideLabelText
    : CAMPAIGN_TYPE_LABEL_KEY[campaignType] ?
      t(($) => $.advertising.campaignNameLabels[CAMPAIGN_TYPE_LABEL_KEY[campaignType]])
    : campaignType;

  const userCanUpdateAds = useSimpleCan("update", "Ad");

  // The plan runs the same lookups to gate its steps; both read them from the query cache.
  const checks = useCampaignNameChecks(
    needsCampaignNameCheck(state, campaignType, campaignName) ? [campaignName] : [],
    marketPlace,
  );

  return (
    <div
      style={{
        maxWidth: state.id ? "50%" : "70%",
        paddingLeft: "2rem",
        paddingBottom: "1rem",
      }}
    >
      <FormGroupTile
        formControlClass={`text-start ${formControlClasses}`}
        type="formcontrol"
        label={`${labelText}`}
        formControlType={"text"}
        stateName={campaignType}
        handleChildFormElement={(key, value) => {
          handleCampaignNameChange(key, value);
        }}
        labelClassName={labelClassName}
        placeholder={overridePlaceholderText ? overridePlaceholderText : `${labelText}`}
        defaultValue={campaignName}
        style={{ border: "1px solid #BBB" }}
        customLabelStyles={customLabelStyles}
        key={key}
        disabled={isDisabled || !userCanUpdateAds}
      />

      {checks.failed.has(campaignName) ?
        <small className="text-danger pt-3 d-block">{t(($) => $.advertising["Error validating campaign name."])}</small>
      : checks.checking.has(campaignName) ?
        <div className="d-flex align-items-center py-3">
          <Spinner animation="border" role="status" variant="secondary" className="me-3" />
          <small className="text-info">{t(($) => $.advertising["Validating campaign name. Please wait."])}</small>
        </div>
      : checks.taken.has(campaignName) ?
        <small className="text-danger pt-3 d-block">
          {t(($) => $.advertising["Duplicate campaign names found. Please enter a different name."])}
        </small>
      : null}
    </div>
  );
};

export default CampaignNameField;
